export default "/images/left-arrow.png?e202fd7a37258238df45161d3a7edbee";